export default (t) => {
    return  [
        {
            header: t('Op'),
            accessor: 'op',
        },
        {
            header: t('Path'),
            accessor: 'path',
        },
        {
            header: t('Process ID'),
            accessor: 'ppid',
        },
        {
            header: t('Status'),
            accessor: 'status',
        }
    ];
};
